import React from "react";
import { Link } from "react-router-dom";

export default function Strap({ title, content, btn, url }) {
  return (
    <>
      <style>{`
        .strap {
          background: linear-gradient(145deg, #0f172a, #051f4bff);
          color: white;
          text-align: center;
          padding: 60px 20px;
          margin: 40px auto;
          width: 100%;
          box-shadow: 0 8px 25px rgba(0,0,0,0.2);
          position: relative;
          overflow: hidden;
        }

        /* Bubble container */
        .bubbles {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          overflow: hidden;
          z-index: 1;
        }

        /* Individual bubble */
        .bubble {
          position: absolute;
          bottom: -100px;
          border-radius: 50%;
          animation: rise 15s infinite ease-in;
          opacity: 0.8;
          filter: blur(1px);
        }

        @keyframes rise {
          0% {
            transform: translateY(0) scale(1);
            opacity: 0.3;
          }
          100% {
            transform: translateY(-120vh) scale(1.5);
            opacity: 0;
          }
        }

        /* Heading */
        .strap h2 {
          font-size: 2.5rem;
          margin-bottom: 20px;
          font-weight: bold;
          background: linear-gradient(145deg, #eff8faff, #fcffffff, #fff);
          text-transform: uppercase;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          position: relative;
          z-index: 2;
        }

        /* Paragraph */
        .strap p {
          font-size: 1.2rem;
          max-width: 800px;
          margin: 0 auto;
          line-height: 1.8;
          color: #e5e7eb;
          position: relative;
          z-index: 2;
        }

        @media (max-width: 768px) {
          .strap {
            padding: 40px 15px;
          }
          .strap h2 {
            font-size: 1.8rem;
          }
          .strap p {
            font-size: 1rem;
          }
        }
      `}</style>

      <div className="strap">
        {/* Bubble background */}
        <div className="bubbles">
          {Array.from({ length: 20 }).map((_, i) => {
            // Generate light colors (pastel)
            const hue = Math.floor(Math.random() * 360); // random hue
            const color = `hsla(${hue}, 80%, 70%, 0.7)`; // pastel-like

            return (
              <span
                key={i}
                className="bubble"
                style={{
                  left: `${Math.random() * 100}%`,
                  width: `${20 + Math.random() * 40}px`,
                  height: `${20 + Math.random() * 40}px`,
                  background: color,
                  animationDuration: `${8 + Math.random() * 10}s`,
                  animationDelay: `${Math.random() * 5}s`,
                }}
              ></span>
            );
          })}
        </div>

        <h2>{title}</h2>
       
      </div>
    </>
  );
}
